export default "__VITE_ASSET__66dbe239__"